var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('Header'),_c('div',{staticClass:"container"},[_c('Menu'),_c('div',{staticClass:"content"},[_c('transition',{attrs:{"name":"page-transform","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }